import {
  StorefrontSdkError,
  consumeStorefrontPreviewToken,
  createStorefrontSdk,
  type StorefrontBootstrap,
} from "@emynor/storefront-sdk";
import { loadStorefrontBootstrap } from "./bootstrap";

let initializationError: StorefrontSdkError | null = null;
let previewToken: string | null = null;

try {
  previewToken = consumeStorefrontPreviewToken({ location: window.location, history: window.history });
} catch (error) {
  initializationError = error instanceof StorefrontSdkError
    ? error
    : new StorefrontSdkError({ code: "storefront_preview_invalid", message: "The preview session is invalid", status: 401 });
}

export const storefrontSdk = createStorefrontSdk({
  previewToken,
  baseUrl: import.meta.env.DEV ? import.meta.env["VITE_API_BASE_URL"] : undefined,
  developmentTenantHost: import.meta.env.DEV ? import.meta.env["VITE_TENANT_HOST"] : undefined,
});

export async function storefrontBootstrap(signal?: AbortSignal): Promise<StorefrontBootstrap> {
  if (initializationError) return Promise.reject(initializationError);
  return loadStorefrontBootstrap(() => storefrontSdk.bootstrap(signal ? { signal } : undefined));
}
